import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import backicon from "../../../../../Assets/icons/backIcon.svg"
import deleteIcon from "../../../../../Assets/icons/trash.svg"

import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg"
import './AddCustomer.scss'
import axiosInstance from '../../../../services/api/API';
import AddIssueDynemicForm from '../../../Services/addIssueDynemicFrom';
import { Modal, Offcanvas } from "react-bootstrap";
import moment from "moment";
import { showCustomAlert } from '../../../../customComponents/CustomSweetAlert';
import { showErrorAlert } from '../../../../customComponents/CustomSweetAlert/errorsweetalert';
import Drawer from "react-modern-drawer";
import CustomTable from '../../../../customComponents/CustomTable';
import SalesDynamicForm from '../../SalesComponents/SalesDynamicform';
import Swal from 'sweetalert2';
import { min18YearsAgo } from '../../../../../constants/DOBCommon';


const AddProposal = () => {

  const navigate = useNavigate()

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  const [ subsidyPriceData , setSubsidyPriceData ] = useState(0)

  const [ vehicleFormData, setVehicleFormData ] = useState({})

  const [ accessoryIdVal, setAccessoryIdVal ] = useState(0)

  const [ taxPercentVal, setTaxPercentVal ] = useState(0)

  const [openCustomerModel, setOpenCustomerModel] = useState(false);
  const [validationErrors,setValidationErrors] = useState({})

  const [showForms, setShowForms] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [showParentDesignation, setShowParentDesignation] = useState(false);
  const [occupationDD, setOccupationDD] = useState([]);
  const [languageDD, setLanguageDD] = useState([]);
  const [activeButton, setActiveButton] = useState("customer");
  const [showVehicleForm, setShowVehicleForm] = useState(false);

  const [make, setMake] = useState([]);
  const [model, setModel] = useState([]);
  const [product, setProduct] = useState([]);
  const [subproduct, setSubproduct] = useState([]);
  const [variantDD, setVariantDD] = useState([]);

  const [color, setColor] = useState([]);
  const [fuelType, setFuelType] = useState([]);

  const [ fetchFinancer  , setFetchFinancer  ] = useState([])

  const [ quotationIdVal , setQuotationIdVal] = useState(0)

  const [ termsetId , setTermsetId] = useState([])

  const [ rtoListddl  , setRtoListddl ] = useState([])

  const [ quotationStatus, setQuotationStatus ] = useState([])

  const [ showroomPriceData , setExshowRoomPriceData ] = useState(0)

  const [ termConditionVal , setTermConditionVal] = useState([])

  const [ salesPersonDdl , setSalesPersonDdl ] = useState([])

  const [ accessoryVal , setAccessoryVal ] = useState([])

  const [taxVal , setTaxVal ] = useState([])

  const [ unitVal, setUnitVal ] = useState([])

  const [ accessoryTable , setAccessoryTable ] = useState([])

  const [ totalAmountSum , setTotalAmountSum ] = useState(0)

  const [titleDD, setTitleDD] = useState([]);

  const token = localStorage.getItem("authToken");

  const [ customerddl, setCustomerDDl ]  = useState([])
  const [ quotationDdl, setQuotationDdl ] = useState([])

  const [ quotationId, setQuotationId ] = useState([])

  const [ proposalIdVal , setProposalIdVal ] = useState(0)

  const [ leadCodeOPtions, setLeadCodeOptions ] = useState([])

  const [ visitTypeDdl , setVisitTypeDdl ] = useState([])

  const [ custVisitTypeId, setCustVisitTypeId ] = useState([])

  const [ isEdit, setIsEdit ] = useState(false)

  const [ showRoomIdVal , setShowroomIdVal ] = useState(0)

  const location = useLocation();
  const { data } = location.state || {};

  // Dropdown for customer dropdown



  useEffect(() => {
    fetchCustomerDdList()
  },[])

  useEffect(() => {
    const custId = formData.lead_customer_id;
    console.log(custId, "CustId")
    if(custId){
      fetchCustomerList(custId);
    }
  }, [formData.lead_customer_id]);

  const fetchCustomerList = async (custId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/proposal/ddlcustomerlist",
        {
          business_partner_id,
          customer_id:custId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const fetchedData = response.data.data[0]
      console.log(fetchedData, "FETCHEDCUSTDATA")

      const formatedData = {
        lead_customer_id:custId,
        mobile_no: fetchedData.mobile_no,
        // transaction_no:fetchedData.transaction_no,
        // visit_date:fetchedData.,
        address:fetchedData.address,
        pincode: fetchedData.pincode,
        city_id: fetchedData.city_id,
        state_id: fetchedData.state_id,
        country_id: fetchedData.country_id,
        // finance_city_id:fetchedData.city_id

      }

      setFormData(formatedData)
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };
  
  const fetchCustomerDdList = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/proposal/ddlcustomerlist",
        {
          business_partner_id,
          customer_id:""
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.map((data) => ({
        label: data.NAME,
        value: data.lead_customer_id,
      }));

      setCustomerDDl(options);

      const customerId = options.lead_customer_id
      console.log(customerId, "custId")
      // console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  // Dropdown for lead Options

  useEffect(() => {
    const custId = formData.lead_customer_id;
    console.log(custId, "CustId")
    if(custId){
      fetchQuotationLeadCodeList(custId);
      setLeadCodeOptions([])
    }
  }, [formData.lead_customer_id]);

  const fetchQuotationLeadCodeList = async (custId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/proposal/getquotationcodebycustomerId",
        {
          business_partner_id,
          customer_id: custId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setLeadCodeOptions(options)

      // setCustomerDDl(options);
      console.log(options, "leadOPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  }

  useEffect(() => {
    const quotationId = formData.quotation_id;
    console.log(quotationId, "leadId")
    if(quotationId){
      fetchQuotationAgainstLead(quotationId);
      // setLeadCodeOptions([])
    }
  }, [formData.quotation_id]);


  const fetchQuotationAgainstLead = async (quotationId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/proposal/againsedquotationlist",
        {
          business_partner_id,
          quotation_id: quotationId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const fetchedData = response.data.data[0];
      console.log(fetchedData, "FETCHEDCUSTDATA");
  
      const formatedData = {
        salesperson_id: fetchedData.salesperson_id,
        showroom_id: fetchedData.showroom_name,
        product_id: fetchedData.product_id,
        subproduct_id: fetchedData.subproduct_id,
        make_id: fetchedData.make_id,
        model_id: fetchedData.model_id,
        variant_id: fetchedData.variant_id,
        color_id: fetchedData.color_id,
        fueltype_id: fetchedData.fuel_type_id,
        exshowroom_price: fetchedData.exshowroomprice,
        cust_subsidy_price:fetchedData.subsidyprice
      };

      const subsidypriceVal = fetchedData.subsidyprice
      console.log(subsidypriceVal, "subsidypriceVal")
      setSubsidyPriceData(subsidypriceVal)

      const showRoomId = fetchedData.showroom_id
      console.log(showRoomId, "showroom_id")
      setShowroomIdVal(showRoomId)

      const quotationIdData = fetchedData.quotation_id
      setQuotationIdVal(quotationIdData)

      const termSetId = fetchedData.termset_id;
      setTermsetId(termSetId)

       const exShowroomPriceVal = fetchedData.exshowroom_price
          console.log(exShowroomPriceVal, "exShowroomPriceVal")
          setExshowRoomPriceData(exShowroomPriceVal)
  
      setFormData((prevData) => ({
        ...prevData, // Preserve existing form data
        ...formatedData // Merge new vehicle data
      }));
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    console.log(formData, "quotationformdata")
  },)
 


  useEffect(() => {
    fetchQuotationTypeDdList()
  },[])

  const fetchQuotationTypeDdList = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/quotationtype/list",
        {
          orderBy:"quotation_type_id desc" ,
          page:0,
          pageSize:10
          // customer_id:""
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.quotation_type,
        value: data.quotation_type_id,
      }));

      console.log(options, "quotationhello")

      setQuotationDdl(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  // Dropdown for Product, sub-product etc

    
  useEffect(() => {
    fetchProductOptions();
  }, []);

  const fetchProductOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/product/ddlproduct",
        {
          business_partner_id: 1
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setProduct(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    const productId = formData.product_id;
    if(productId){
      fetchSubproduct(productId);
      setSubproduct([])
    }
  }, [formData.product_id]);

  const fetchSubproduct = async (productId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/subproduct/ddlsubproduct",
        {
          business_partner_id,
          product_id: productId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setSubproduct(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    const subProductId = formData.subproduct_id;
    const productId = formData.product_id;
    if (subProductId && productId){
      fetchMakeDD(subProductId, productId)
      setMake([])
    }
  },[formData.subproduct_id, formData.product_id])

  const fetchMakeDD = async (productId, subProductId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/make/ddlmake",
        {
          business_partner_id,
          product_id: subProductId,
          subproduct_id: productId , 
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data.data;
      const makedata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setMake(makedata);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    const subProductId = formData.subproduct_id;
    const makeId = formData.make_id;
    const productId = formData.product_id;
    if (productId && makeId && subProductId) {
      fetchModelDD(makeId, productId, subProductId);
      setModel([]);
    }
  }, [formData.make_id, formData.product_id,formData.subproduct_id ]);

  const fetchModelDD = async (makeId, productId, subProductId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/model/ddlmodel",
        {
          business_partner_id,
          product_id: productId,
          make: makeId,
          subproduct_id: subProductId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data.data;
      const modeldata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setModel(modeldata);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {

    const subProductId = formData.subproduct_id;
    const makeId = formData.make_id;
    const productId = formData.product_id;
    const modelId = formData.model_id

    if (productId && makeId && subProductId && modelId) {
      fetchVariantDD(makeId, productId, subProductId, modelId);
      setVariantDD([]);
    }

    // fetchVariantDD()
  },[formData.make_id, formData.product_id,formData.subproduct_id,formData.model_id])

  const fetchVariantDD = async (makeId, productId, subProductId, modelId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {
          business_partner_id,
          product_id: productId,
          make: makeId,
          subproduct_id: subProductId,
          model_id:modelId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data.data;
      const variantdata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setVariantDD(variantdata);
    } catch (error) {
      console.log(error, "error");
    }
  };


  // Dropdown for terms and condition 


  useEffect(() => {
    fetchTermsCondition();
  }, []);

  const fetchTermsCondition = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/quotation/ddltermslist",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.map((data) => ({
        label: data.term_name,
        value: data.term_id,
      }));

      setTermConditionVal(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  // Dropdown fro quotation status 

  useEffect(() => {
    fetchQuotationStatus()
  },[])

  const fetchQuotationStatus = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/quotation/ddlquotationstatuslist",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.map((data) => ({
        label: data.quotation_status,
        value: data.quotation_status_id,
      }));

      setQuotationStatus(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };


  // Dropdown for color and fuelType


  useEffect(() => {
    fetchName()
  },[])

  const fetchName = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/proposal/ddlfinancerlist",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.map((data) => ({
        label: data.financer_name,
        value: data.financer_id,
      }));

      setFetchFinancer(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    fetchFuelType();
  }, []);

  const fetchFuelType = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/fueltype/ddlfueltype",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setFuelType(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    fetchRTOList()
  },[])

  const fetchRTOList = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/proposal/ddlrtolist",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.map((data) => ({
        label: data.rtolabel,
        value: data.rto_id,
      }));

      setRtoListddl(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };


  useEffect(() => {
    fetchSalesPerson();
  }, []);

  const fetchSalesPerson = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/quotation/ddlselspersonlist",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.map((data) => ({
        label: data.user_name,
        value: data.user_id,
      }));

      setSalesPersonDdl(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    fetchUnit()
  },[])

  const fetchUnit = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/quotation/ddlunitlist",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.map((data) => ({
        label: data.unit,
        value: data.unit_id,
      }));

      setUnitVal(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    const quotationIdValue = formData.quotation_id;
    console.log(quotationIdValue, "CustId")
    if(quotationIdValue){
      fetchaccessorytable(quotationIdValue);
      // setLeadCodeOptions([])
    }
  }, [formData.quotation_id]);

  const fetchaccessorytable = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/proposal/accessorieslist",
        {
          business_partner_id,
          quotation_id:quotationIdVal,
          // proposal_id:""
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response, "resposne")

      const formatedData = response?.data?.data.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  ,

      }));

       // Calculating the total of 'Total Amount'
       const totalAmountSum = response?.data?.data.reduce((sum, item) => {
        return sum + parseFloat(item.total_amount);
      }, 0).toFixed(2);
    setTotalAmountSum(totalAmountSum)

    console.log("Total Amount Sum:", totalAmountSum);

      setAccessoryTable(formatedData)

      const fetchedData = ({
        accessories: totalAmountSum
      })

        setFormData((prevData) => ({
          ...prevData, // Preserve existing form data
          ...fetchedData
        }));
    


    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {

    fetchAccessoryList()

  },[])

  const fetchAccessoryList = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/quotation/ddlaccessorieslist",
        {
          business_partner_id,
          item_id:""
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.map((data) => ({
        label: data.item_name,
        value: data.item_id,
      }));

      setAccessoryVal(options);

      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };



  // Prepopulating the accessory list

  // useEffect(() => {
  //   fetchGetAccessoryList()
  // },[])

  useEffect(() => {
    const itemId = formData.item_id;
    console.log(itemId, "CustId")
    if(itemId){
      fetchGetAccessoryList(itemId);
    }
  }, [formData.item_id]);

  const fetchGetAccessoryList = async (itemId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/quotation/ddlaccessorieslist",
        {
          business_partner_id,
          item_id:itemId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.map((data) => ({
        label: data.item_name,
        value: data.item_id,
      }));

      setAccessoryVal(options);


      const fetchedData = response.data.data[0]
      const formatedData = ({
        item_id:fetchedData.item_id,
        Unit_id:fetchedData.Unit_id,
        taxes_id:fetchedData.taxes_id,
        rate:fetchedData.selling_price
      })

      setFormData((prevData) => ({
        ...prevData, // Preserve existing form data
        ...formatedData // Merge new vehicle data
      }));

      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };



  useEffect(() => {
    fetchTax()
  },[])

  const fetchTax = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/quotation/ddltaxlist",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.map((data) => ({
        label: data.tax_name,
        value: data.taxes_id,
        percent: data.tax_percent
      }));

      setTaxVal(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };


  useEffect(() => {
    fetchColorOptions()
  },[])

  const fetchColorOptions = async () => {
    try {

      const business_partner_id = 1;

      const response = await axiosInstance.post('/color/ddlcolor', {
        business_partner_id
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const options = response.data.data.data.map(color => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColor(options);
    } catch (error) {
      console.error('Error fetching color options:', error);
    }
  };

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };


  const CustomerInputs = [  
    {
      name: "lead_customer_id",
      label: "Customer Name",
      type: "dropdown",
      placeholder:"Enter Customer Name",
      options:customerddl,
      required: true,
      // iscustomer:true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "proposal_date",
      label: "Proposal Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, message: "Date is required", },
    },
    // {
    //   name: "customer_type",
    //   label: "Customer Type ",
    //   type: "dropdown",
    //   options: [
    //     { label: "Individual", value: "Individual" },
    //     { label: "Corporate", value:"Corporate" }
    //   ],
    //   gridClass: "col-lg-4",
    //   // validation: { required: true },
    //   required: true,
    // },
    // {
    //   name: "quotationtype_id",
    //   label: "Quotation Type",
    //   type: "dropdown",
    //   options:quotationDdl,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   // required: false,
  
    // },
    {
      name: "quotation_id",
      label: "Quotation No.",
      type: "dropdown",
      placeholder:"Enter Customer Type",
      options:leadCodeOPtions,
      required: true,
      gridClass: "col-lg-4",
      required: false,
      validation: { required: true },
      // isVisible: false
    },
    {
      name: "mobile_no",
      label: "Contact No.",
      type: "text",
      placeholder:"Enter Contact No.",
      // options:titleoptions,
      required: true,
      validation: { 
        required: true, pattern: /^[6-9]/ ,
        minLength:10,
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      },
      gridClass: "col-lg-4",
      disabled:true,
      // validation: { required: true },
    },
    { 
      name: "address",
      label: "Address",
      type: "text",
      placeholder:"Enter Address",
      // options:leadSourceOptions,  
          required: true,
      gridClass: "col-lg-4",
      disabled:true,
      // validation: { required: true },
    },
  
    {
      name: "pincode",
      label: "Pin Code",
      type: "text",
      required: true,
      placeholder:"Enter Pincode",
      gridClass: "col-lg-4",
      disabled:true,
      // validation: { required: true },
    },
   
    {
      name: "city",
      label: "City",
      type: "text",
      placeholder:"Enter City Name",
      required: true,
      gridClass: "col-lg-4",
      disabled:true
    },
    {
      name: "state",
      label: "State",
      type: "text",
      placeholder:"Enter State",
      required: true,
      gridClass: "col-lg-4",
      disabled:true
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      placeholder:"Enter Country",
      required: true,
      gridClass: "col-lg-4",
      disabled:true
    },
    {
      name: "showroom_id",
      label: "Dealer Branch",
      type: "text",
      placeholder:"Enter Dealer Name",
      // options:[],
      required: true,
      gridClass: "col-lg-4",
      required: false,
      disabled:true,
      // validation: { required: true },
    },
    {
      name: "salesperson_id",
      label: "Sales Person",
      type: "dropdown",
      placeholder:"Enter Customer Type",
      options:salesPersonDdl,
      required: true,
      gridClass: "col-lg-4",
      required: false,
      disabled:true,
      // validation: { required: true },
    },
    {
      name: "customersubsidy",
      label: "Customer Subsidy",
      type: "dropdown",
      // placeholder:"Enter Customer Type",
      options: [
        { id: 1, label: "Yes", value: "Yes" },
        { id: 0, label: "No", value: "No" },
      ],
      required: true,
      gridClass: "col-lg-4",
      required: false,
      // disabled:true,
      // validation: { required: true },
    },
  ];

    const QuotationInputs = [  
    {
      name: "exshowroom_price",
      label: "Ex-showroom Price",
      type: "text",
      placeholder:"Enter Ex-Showroom Price ",
      // options:customerddl,
      required: true,
      // iscustomer:true,
      gridClass: "col-lg-4",
      disabled:true,
      // validation: { required: true },
    },
    {
      name: "cust_subsidy_price",
      label: "Customer Subsidy Price",
      type: "text",
      placeholder:"Enter Subsidy Price ",
      // options:customerddl,
      required: true,
      // iscustomer:true,
      gridClass: "col-lg-4",
      disabled:true,
      // validation: { required: true },
    },
    {
      name: "finalPrice",
      label: "Final Price(Exshowroom Price - Subsidy Price) ",
      type: "text",
      placeholder:"Enter Final Price ",
      // options:customerddl,
      required: true,
      // iscustomer:true,
      gridClass: "col-lg-4",
      disabled:true,
      // validation: { required: true },
    },
    {
      name: "platecharges",
      label: "Plate Charges",
      type: "number",
      placeholder:"Enter Plate Charges",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "insurance",
      label: "Insurance",
      type: "number",
      placeholder:"Enter Insurance",
      required: true,
      gridClass: "col-lg-4",
      required: true,
      validation: { required: true },
  
    },
    {
      name: "rto_amount",
      label: "RTO Amount",
      type: "number",
      placeholder:"Enter RTO Amount",
      required: true,
      gridClass: "col-lg-4",
      required: true,
      validation: { required: true },
    },
    {
      name: "accessories",
      label: "Accesssory Cost",
      type: "number",
      placeholder:"Enter Customer Type",
      // options:[],
      isaccessory:true,
      required: true,
      gridClass: "col-lg-4",
      required: false,
      validation: { required: true },
      disabled:true
      // isVisible: false
    },
    {
      name: "discounttype",
      label: "Discount Type",
      type: "dropdown",
      placeholder:"Enter Contact No.",
      options:[
        { label: "Percentage", value: "P" },
        { label: "Amount", value: "A" },
      ],
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      // disabled:true
    },
    {
      name: "discount",
      label: "Discount Amount",
      placeholder:"Enter Discount Amount",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      // disabled:true
    },
    { 
      name: "taxset_id",
      label: "Tax Set",
      type: "dropdown",
      // placeholder:"Enter Tax Set",
      options:taxVal,  
          required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      // disabled:true
    },
    {
      name: "taxamount",
      label: "Tax Amount",
      type: "number",
      required: true,
      placeholder:"Enter Tax Amount",
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled:true
    },
    {
      name: "onroadprice",
      label: "Onroad Price Round",
      type: "text",
      placeholder:"Enter Onroad Price",
      required: true,
      gridClass: "col-lg-4",
      disabled:true
    },
    {
      name: "onboardPriceRoundoff",
      label: "Onroard Price Round Off",
      type: "text",
      placeholder:"Enter Onroard Price",
      required: true,
      gridClass: "col-lg-4",
      disabled:true
    },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      placeholder:"Enter Remark",
      required: true,
      gridClass: "col-lg-4",
      // disabled:true
      validation: { required: true },
    },
   
  ];

  useEffect(() => {
    console.log(formData, "financeformdata") 
  })

  const FinanceInputs = [  
    {
      name: "financerequired",
      label: "Finance Required",
      type: "dropdown",
      options: [
        { id: 1, label: "Yes", value: "Yes" },
        { id: 0, label: "No", value: "No" },
      ],
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "financer_id",
      label: "Finance Name  ",
      type: "dropdown",
      options:fetchFinancer,
      placeholder:"Enter Finance Name",
      required: true,
      gridClass: "col-lg-4",
      isVisible: false
    },
    {
      name: "finance_amount",
      label: "Finance Amount  ",
      type: "number",
      placeholder:"Enter Finance Amount",
      required: true,
      gridClass: "col-lg-4",
      isVisible: false
    },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder: "Enter Pincode",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,
         maxLength: 6 
        },
    },
    {
      name: "city",
      label: "Finance City  ",
      type: "text",
      placeholder:"Enter Finance City",
      required: false,
      gridClass: "col-lg-4",
      isVisible: false
    },
    {
      name: "balance_amount",
      label: "Payabale Amount  ",
      type: "text",
      // options:visitTypeDdl ,
      placeholder:"Payable Amount",
      required: true,
      gridClass: "col-lg-4",
      disabled:true,
      // validation: { required: true },
    },
    // {
    //   name: "quotation_status_id",
    //   label: "Quotation Status",
    //   type: "dropdown",
    //   placeholder:"Enter Customer Type",
    //   options:quotationStatus,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   required: false,
    //   validation: { required: true },
    // },
    
   
  ];

  const AccessoryInputs = [  
    {
      name: "item_id",
      label: "Accessory Name",
      type: "dropdown",
      // placeholder:"Enter Customer Name",
      options:accessoryVal,
      required: true,
      // iscustomer:true,
      gridClass: "col-lg-6",
    },
    {
      name: "Unit_id",
      label: "Unit",
      type: "dropdown",
      options:unitVal ,
      // placeholder:"Enter No.",
      required: true,
      gridClass: "col-lg-6",
      // disabled:true
    },
    {
      name: "taxes_id",
      label: "Tax",
      type: "dropdown",
      options:taxVal ,
      // placeholder:"Enter No.",
      required: true,
      gridClass: "col-lg-4",
      // disabled:true
    },
    {
      name: "quantity",
      label: "Quantity",
      type: "number",
      placeholder:"Enter Quantity",
      // options:[],
      required: true,
      gridClass: "col-lg-4",
      required: false,
    },
    {
      name: "rate",
      label: "Rate",
      type: "text",
      // options:visitTypeDdl ,
      placeholder:"Enter Rate",
      required: true,
      gridClass: "col-lg-4",
    },
    // {
    //   name: "tax_amount",
    //   label: "Tax Amount",
    //   type: "text",
    //   // options:visitTypeDdl ,
    //   // placeholder:"Enter No.",
    //   required: true,
    //   gridClass: "col-lg-4",
    // },
    
   
  ];

  const VehicleInputs = [
    {
      name: "product_id",
      label: "Product",
      type: "dropdown",
      options: product,
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled:true
    },

    {
      name: "subproduct_id",
      label: "Subproduct Name",
      type: "dropdown",
      options: subproduct,
      gridClass: "col-lg-4",
      required: true,
      // validation: { required: true },
      disabled:true
    },
    {
      name: "make_id",
      label: "Make",
      placeholder: "Select City",
      type: "dropdown",
      options: make,
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled:true
    },
    {
      name: "model_id",
      label: "Model",
      placeholder: "Select ",
      type: "dropdown",
      options: model,
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled:true
    },
    {
      name: "variant_id",
      label: "Variant",
      type: "dropdown",
      options: variantDD,
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled:true
    },
    {
      name: "color_id",
      label: "Color",
      type: "dropdown",
      options: color,
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled:true
    },
    {
      name: "fueltype_id",
      label: "Fuel Type",
      type: "dropdown",
      options: fuelType,
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled:true
    },
    {
      name: "rto_id",
      label: "RTO Code",
      type: "dropdown",
      options: rtoListddl,
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      // disabled:true
    },
    {
      name: "location",
      label: "Location",
      type: "text",
      placeholder:"Enter Location",
      // options: rtoListddl,
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      // disabled:true
    },

    {
      name: "is_ext_warranty",
      label: "Extended Warranty",
      type: "toggle",
      required: false,
      options: [{ label: "Extended Warranty", value: 1 }],
      gridClass: "col-lg-4",
      // validation: { required: true },
    },
    // {
    //   name: "termset_id",
    //   label: "Terms & Condition",
    //   type: "dropdown",
    //   options: termConditionVal,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    //   // disabled:true
    // }
  ];

  const handleClose = () => {
    setOpenCustomerModel(false);
    // setFormData({})
  };
  const onclickOpenFrom = () => {
    setOpenCustomerModel(true);
  };

  const handleFormSubmit = async (formData) => {

    const errors = {};
    let isValid = true;

    if (!showForms  ){
      CustomerInputs.forEach((field) => {
        if (field.validation && field.validation.required) {
          if (!formData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          }
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      });
      VehicleInputs.forEach((field) => {
        if (field.validation && field.validation.required) {
          if (!formData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          }
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      });
    }
    if(showForms === true){
      QuotationInputs.forEach((field) => {
        if (field.validation && field.validation.required) {
          if (!formData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          }
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      });
  
      FinanceInputs.forEach((field) => {
        if (field.validation && field.validation.required) {
          if (!formData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          }
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      });
    }


    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to create this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
    try {
      if (!showForms) {
        // First, submit the create request
        const response = await axiosInstance.post(
          "/proposal/create",
          {

            transaction_code:formData.transaction_code,
            rto_id:formData.rto_id,
            finance_transaction_no: formData.finance_transaction_no || null,
            finance_city_id:formData.city_id || null,
            is_allotted:0,
            // customer_subsidy: 1,
            // custsubsidyprice: subsidyPriceData|| null,
            cust_subsidy_price: subsidyPriceData|| null,
            is_ext_warranty: formData.is_ext_warranty ? 1 : 0,
            ext_warranty_start_date:formData.ext_warranty_start_date || null,
            ext_warranty_end_date:formData.ext_warranty_end_date || null,
            ext_amount: formData.ext_amount || null,
            location:formData.location,
            taxset_id :formData.termsetId,
            financer_id:formData.financer_id || null,
            finance_pincode:formData.pincode,
            termset_id: termsetId || null,


            // quotation_id:formData.quotation_id || null,

            business_partner_id: 1,
            quotation_id: formData.quotation_id || null,
            proposal_date: formData.proposal_date,
            customer_id: formData.lead_customer_id,
            quotationtype_id: formData.quotationtype_id,
            salesperson_id: formData.salesperson_id,
            product_id: formData.product_id || null,
            subproduct_id: formData.subproduct_id || null,
            make_id: formData.make_id || null,
            model_id: formData.model_id || null,
            variant_id: formData.variant_id || null,
            color_id: formData.color_id || null,
            fueltype_id: formData.fueltype_id || null,
            showroom_id: showRoomIdVal || null,
            // discount_id: formData.discount_id || null,
            exshowroom_price: formData.exshowroom_price || null,
            plate_charges: formData.platecharges || null,
            insurance: formData.insurance || null,
            rto_amount: formData.rto_amount || null,
            accessory_cost: formData.accessories || null,
            other: formData.other || null,
            discount: formData.discount || null,
            discount_type: formData.discounttype || null,
            onroad_price: formData.onroadprice || null,
            remark: formData.remark || null,
           
            finance_required : formData.financerequired === "Yes" ? 1 : 0,
            finance_amount: formData.finance_amount || null,
            balance_amount: formData.balance_amount || null,
            // quotation_status_id: formData.quotation_status_id || null,
            // lead_lost_reason_id: formData.lead_lost_reason_id || null,
            taxset_id: formData.taxset_id || null,
            tax_amount: formData.taxamount || null,
            // parent_quotation_id: formData.parent_quotation_id || null,
            // discount_approval: formData.discount_approval || null,
            // approval_remark: formData.approval_remark || null,
            status: 1,
            // termset_id: formData.termset_id || null,
            customer_subsidy: formData.customersubsidy === "Yes" ? 1 : 0 || null,
            cust_subsidy_price: subsidyPriceData|| null
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        const proposalIdVal = response.data.data.responseData.proposal_id;
        console.log(quotationIdVal, "quotationIdVal");
        setProposalIdVal(proposalIdVal);
  
        if (response.status === 200) {
          setShowForms(true);
          fetchaccessorytable()
        }
      } else {
        // If showForms is true, submit the update request
        const response = await axiosInstance.patch(
          `/proposal/update/${proposalIdVal}`, 
          {
            transaction_code:formData.transaction_code,
            rto_id:formData.rto_id,
            finance_transaction_no: formData.finance_transaction_no || null,
            finance_city_id:formData.city_id || null,
            is_allotted:0,
            is_ext_warranty: formData.is_ext_warranty ? 1 : 0,
            ext_warranty_start_date:formData.ext_warranty_start_date || null,
            ext_warranty_end_date:formData.ext_warranty_end_date || null,
            ext_amount: formData.ext_amount || null,
            location:formData.location,
            taxset_id :formData.taxset_id || null,
            finance_pincode:formData.pincode,
            termset_id: termsetId || null,

            // quotation_id:formData.quotation_id || null,

            business_partner_id: 1,
            quotation_id: formData.quotation_id || null,
            proposal_date: formData.proposal_date,
            customer_id: formData.lead_customer_id,
            quotationtype_id: formData.quotationtype_id,
            salesperson_id: formData.salesperson_id,
            product_id: formData.product_id || null,
            subproduct_id: formData.subproduct_id || null,
            make_id: formData.make_id || null,
            model_id: formData.model_id || null,
            variant_id: formData.variant_id || null,
            color_id: formData.color_id || null,
            fueltype_id: formData.fueltype_id || null,
            showroom_id: showRoomIdVal || null,
            // discount_id: formData.discount_id || null,
            exshowroom_price: formData.exshowroom_price || null,
            plate_charges: formData.platecharges || null,
            insurance: formData.insurance || null,
            rto_amount: formData.rto_amount || null,
            accessory_cost: formData.accessories || null,
            other: formData.other || null,
            discount: formData.discount || null,
            discount_type: formData.discounttype || null,
            onroad_price: formData.onroadprice || null,
            remark: formData.remark || null,
            
            finance_required : formData.financerequired === "Yes" ? 1 : 0,
            finance_amount: formData.finance_amount || null,
            balance_amount: formData.balance_amount || null,
            // quotation_status_id: formData.quotation_status_id || null,
            // lead_lost_reason_id: formData.lead_lost_reason_id || null,
            taxset_id: formData.taxset_id || null,
            tax_amount: formData.taxamount || null,
            financer_id:formData.financer_id || null,
            // parent_quotation_id: formData.parent_quotation_id || null,
            // discount_approval: formData.discount_approval || null,
            // approval_remark: formData.approval_remark || null,
            status: 1,
            // termset_id: formData.termset_id || null,
            customer_subsidy: formData.customersubsidy === "Yes" ? 1 : 0 || null,
            cust_subsidy_price: formData.cust_subsidy_price || null,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          Swal.fire({
            title: "Success",
            text: "Proposal added successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            navigate("/manage-sales/proposal")
          });
        }

        
      }
    } catch (error) {
      console.log(error);

      const errorMessage = error.response?.data?.message

      showErrorAlert({
        title: "Something went wrong",
        text: errorMessage || "An error occurred while processing your request.",
        callback: () => { 
          // Optional: code to execute after confirming the alert
          console.log("Error alert confirmed");
        }
      });
    }
  },
});

if (!result.isConfirmed) {
  setLoading(false); 
}

  };
  

  useEffect(() => {
    console.log(formData, "AccessoryData") 
  })

  useEffect(() => {

    if(formData?.taxes_id ){
      const selectedTax = taxVal?.find(option => option?.value === formData?.taxes_id);
      console.log(selectedTax, "SELECTEDTAX")
      const taxPercent = selectedTax ? selectedTax.percent : 0;
      console.log(taxPercent, "taxpercent")
      setTaxPercentVal(taxPercent)

    }

  },[formData?.taxes_id])


  const handleDrawerFormSubmit = async (formData) => {
    try {
      const payload = {
        business_partner_id: 1,
        quotation_id: quotationId,
        logistic_accessories_id: formData.item_id,
        unit_id: formData.Unit_id,
        taxes_id: formData.taxes_id,
        tax_percent: taxPercentVal,
        quantity: formData.quantity,
        rate: formData.rate,
        total_amount: 0,
        tax_amount: 0,
        is_accessory_allocated: null,
        proposal_id: null,
        invoice_id: null,
      };
  
      let response;
      if (isEdit) {
        // For edit case, send PATCH request to update accessory
        response = await axiosInstance.patch(
          `/quotation/updateaccessory/${accessoryIdVal}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setIsEdit(false)
      } else {
        // For create case, send POST request to create accessory
        response = await axiosInstance.post(
          "/quotation/createaccessory",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
  
      if (response?.data?.status === 200) {
        // setFormData({});
        fetchaccessorytable(); // Refresh the table after successful submission
        handleClose();
      }
    } catch (error) {
      console.log(error, "ERROR");
    }
  };
  

  const CustomerFromInput = [
    {
      name: "title_id",
      label: "Title",
      type: "dropdown",
      required: true,
      // validation:{required:true},
      options: titleDD,
      gridClass: "col-lg-10",
    },
    {
      name: "first_name",
      label: "First Name",
      type: "text",
      required: true,
      placeholder: "Enter First Name",
      gridClass: "col-lg-10",
      validation: { required: true,
        pattern: /^[A-Za-z\s]*$/,
        message: "Only alphabets are allowed*",
        maxLength:25,
       },
      // disabled: true,
    },
    {
      name: "last_name",
      label: "Last Name",
      type: "text",
      placeholder: "Enter Last Name",
      // required: true,
      gridClass: "col-lg-10",
      validation: { required: true ,
        pattern: /^[A-Za-z\s]*$/,
        message: "Only alphabets are allowed*",
        maxLength:25,
      },
      // disabled: true,
    },
    {
      name: "mobile_no",
      label: "Mobile No.",
      type: "text",
      required: true,
      placeholder: "Enter Mobile No.",
      gridClass: "col-lg-10",
      validation: { 
        required: true, pattern: /^[6-9]/ ,
        minLength:10,
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      }
      // disabled: true,
    },
    {
      name: "dob",
      label: "DOB",
      type: "date",
      maxDate: min18YearsAgo,
      required: true,
      gridClass: "col-lg-10",
      validation: { required: true, message: "DOB is required" },
    },
    {
      name: "email_id",
      label: "Email Id",
      type: "text",
      required: true,
      placeholder: "Enter Email Id",
      gridClass: "col-lg-10",
      validation: { required: true,
        pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
        message: "Please Enter Valid Email Id*",
        maxLength:25,
       },
      // disabled: true,
    },
    {
      name: "address",
      label: "Address",
      type: "text",
      required: true,
      placeholder: "Enter Address",
      gridClass: "col-lg-10",
      validation: { required: true },
      // disabled: true,
    },
    {
      name: "occupation_id",
      label: "Occupation",
      type: "dropdown",
      required: true,
      options: occupationDD,
      gridClass: "col-lg-10",
      validation: { required: true },
    },
    {
      name: "language_id",
      label: "Language",
      type: "dropdown",
      required: true,
      options: languageDD,
      gridClass: "col-lg-10",
      validation: { required: true },
    },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder: "Enter Pincode",
      type: "text",
      required: true,
      gridClass: "col-lg-10",
      validation: { required: true,
         maxLength: 6 
        },
    },
    {
      name: "city",
      label: "City",
      type: "text",
      placeholder: "City",
      gridClass: "col-lg-10",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "state",
      label: "State",
      type: "text",
      placeholder: "State",
      required: true,
      gridClass: "col-lg-10",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      placeholder: "Country",
      required: true,
      gridClass: "col-lg-10",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "pan_no",
      label: "PAN No.",
      type: "text",
      placeholder: "Enter PAN No.",
      validation: {
        required: true,
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        message: "Please enter a valid 10-character PAN number",
      },
      required: false,
      gridClass: "col-lg-10",
    },
  ];

  const DEPARTMENT_TABLE_HEADERS = [
    // "Sr No.",
    // "Department ID",
    "Tax Name",
    "Item Name",
    "Unit",
    "Quantity",
    "Rate",
    "Tax Amount",
    "Total Amount",
    // "Action"
  ];


  const DEPARTMENT_KEY_MAPPING = {
    // "Sr No.": "Sr No.",
    // "Department ID": "department_id",
    "Tax Name": "tax_name",
    "Item Name": "item_name",
    "Unit":"unit",
    "Quantity":"quantity",
    "Rate":"rate",
    "Tax Amount": "tax_amount",
    "Total Amount":"total_amount",
    // "Action": [
    //   { type: "edit", icon: editIcon, label: "Edit" },
    //   { type: "delete", icon: deleteIcon, label: "Delete" },
    // ]
  };

  const DEPARTMENT_TABLE_DATA = [
    { id: 1, departmentName: "Finance", description: "Handles financial operations", status: "Active", actions: "Edit/Delete" },
    { id: 2, departmentName: "Human Resources", description: "Manages employee relations", status: "Inactive", actions: "Edit/Delete" },

  ];


  const handleEdit = (rowData) => {
    setIsEdit(true)
    
    const accessoryId = rowData.accessory_id
    console.log(rowData, "handleEdit")
    setAccessoryIdVal(accessoryId)

    const fetchAccessoryEdit = async () => {

      try {
        const response = await axiosInstance.get(
          `/quotation/editaccessory/${rowData?.accessory_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        
        
        const fetchedData = response.data.data
        
        console.log(fetchedData, "resposnedata")

          const transformedData = {
            item_id: fetchedData?.logistic_accessories_id,
            Unit_id: fetchedData.unit_id,
            taxes_id: fetchedData.taxes_id,
            quantity: fetchedData?.quantity,
            rate:fetchedData.rate,
          
          };


          // setFormData(transformedData);
          setFormData((prevData) => ({
            ...prevData, // Preserve existing form data
            ...transformedData // Merge new vehicle data
          }));

          console.log(
            "Transformed vehicle data set to formData:",
            // transformedData
          );

      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      }
     
    }

    fetchAccessoryEdit()
  }


  const handleDelete = async (rowData) => {
    console.log("rowDatadelete>>>>", rowData);

    try {
      const response = await axiosInstance.post(
        `/quotation/deleteaccessory`, {
          business_partner_id:1,
          accessory_id:rowData?.accessory_id
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if(response.status === 200){
        fetchaccessorytable()
      }

    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  // useEffect(() => {
  //   if (subsidyPriceData > 0) {
  //     setFormData((prevData) => ({
  //       ...prevData, // Preserve existing form data
  //       customer_subsidy: "Yes",
  //     }));
  //   }
  // }, [subsidyPriceData, setFormData]);

  useEffect(() => {
    const parsedSubsidyPrice = parseFloat(subsidyPriceData); 
  
    if (parsedSubsidyPrice > 0) {
      setFormData((prevData) => ({
        ...prevData, 
        customersubsidy: "Yes",
      }));
    } else if (parsedSubsidyPrice === 0) {
      setFormData((prevData) => ({
        ...prevData, 
        customersubsidy: "No",
      }));
    }
  }, [subsidyPriceData, setFormData]);

  return (
    <div style={{paddingLeft:10}}>
      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center" , padding:"0 18px"}}>
            <div className="customer-back-buttton mt-2 mb-2">
        <img src={backicon} alt="back" onClick={()=>navigate(-1)} />
        <span className="backbtntitle">Add Proposal</span>
      </div>
      <div className="btncontainer mt-3 gap-2">       
        <button
        onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
          Submit
        </button>
      </div>

      </div>
      <div className="form-container">
        <p style={{fontSize:"20px", color:"grey", paddingTop:"20px", fontWeight:"600"}}>Personal Details </p>
        <DynamicForm

        // formConfig={CustomerInputs}
        formConfig={CustomerInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
        onclickOpenFrom={onclickOpenFrom}
        />
        <div>
        </div>

      <div >
        <p style={{fontSize:"20px", color:"grey", paddingTop:"20px", fontWeight:"600"}}>Vehicle Details </p>
        <DynamicForm
        // formConfig={CustomerInputs}
        formConfig={VehicleInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
        onclickOpenFrom={onclickOpenFrom}
        />
        <div>
        </div>

      </div>

      {showForms && (
        <div>
          <p style={{ fontSize: "20px", paddingTop: "20px", fontWeight: "600" }}>Quotation Details</p>
          <SalesDynamicForm
            formConfig={QuotationInputs}
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleFormSubmit}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            onclickOpenFrom={onclickOpenFrom}
            addComplainHandler={toggleDrawer}
            taxVal={taxVal}
          />

<>
        {" "}
        {isOpen && (
          <Drawer
            size={850}
            open={isOpen}
            onClose={toggleDrawer}
            direction="right"
            className="bla bla bla"
          >
            <div style={{ padding: "30px" }}>
              <div className="backbutton" onClick={toggleDrawer}>
                {/* <img src={backicon} alt="back" /> */}
                <span className="backbtntitleDetails">Add Accesssory</span>
              </div>

              {/* <div className="mt-3">
              <DynamicForm
              formConfig={AccessoryInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleDrawerFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              onclickOpenFrom={onclickOpenFrom}
              addComplainHandler={toggleDrawer}
              />
              </div>
              <div style={{display:"flex", justifyContent:"end", paddingTop:"10px"}}>
              <button
              // style={}
              onClick={() => handleDrawerFormSubmit(formData)}
                className="submit-btn"
                style={{padding:"10px 35px"}}
              >
                Submit
              </button>
              </div> */}
              {/* <hr /> */}

              <CustomTable 
              data={accessoryTable} 
              headers={DEPARTMENT_TABLE_HEADERS} 
              keyMapping={DEPARTMENT_KEY_MAPPING}  
              onEdit={handleEdit}
              onDelete={handleDelete}
          />

            </div>
          </Drawer>
        )}
      </>
        </div>
      )}

      {showForms && (
        <div>
          <p style={{ fontSize: "20px", paddingTop: "20px", fontWeight: "600" }}>Finance Details</p>
          <SalesDynamicForm
  formConfig={FinanceInputs
    .map(input => {
      // Show finance fields only when "Yes" is selected in the financerequired dropdown
      if (["financer_id", "finance_amount", "city", "pincode"].includes(input.name)) {
        return {
          ...input,
          isVisible: formData.financerequired === "Yes",  // Show only when "Yes" is selected
        };
      }
      return input;
    })
    .filter(input => {
      // Filter out finance fields if "Yes" is not selected
      return !["financer_id", "finance_amount", "finance_city_id"].includes(input.name) || formData.financerequired === "Yes";
    })}
  formData={formData}
  setFormData={setFormData}
  onSubmit={handleFormSubmit}
  validationErrors={validationErrors}
  setValidationErrors={setValidationErrors}
  onclickOpenFrom={onclickOpenFrom}
/>



{/* formConfig={CustomerInputs.map(input => {
          if (input.name === "lead_id") {
            return {
              ...input,
              isVisible: formData.visit_type_id !== 1 // Hide "Lead No." only if "New" (ID: 1) is selected
            };
          }
          if (input.name === "visit_type_id") {
            return {
              ...input,
              options: visitTypeDdl // Options received from API response
            };
          }
          return input;
        })} */}


        </div>
      )}
      </div>

    </div>
  )
}

export default AddProposal